import React, { useState, useEffect } from 'react';
import {
  Stack,
  TextField,
  Autocomplete,
} from "@mui/material";

// import { 
//   ModelBase 
// } from "../../models/ModelBase";
import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";

import LoadingBox from "@components/input/LoadingBox";
import { SUGGESTION_FIELD_DATA_TYPE_MAP } from "@dndModels/DataTypeConstants";

interface Props { 
  field: string;
  value?: string | null;
  values?: string[];
  multiple?: boolean;
  name: string;
  onChange: Function;
  color?: string;
  disabled?: boolean;
}

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function SuggestionStringBox({ 
  field, 
  value = null,
  values = [], 
  multiple = false,
  name, 
  onChange, 
  color = "",
  disabled = false }: Props) {
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [myValue, setValue] = useState(value ? value : "");
  const [prev_value, setPrevValue] = useState(value);
  const [value_changed, setValueChanged] = useState(false);
  const [myValues, setValues] = useState(values);
  const [prev_values, setPrevValues] = useState(values);

  useEffect(() => {
    if(!fetched) {
      load();
    }
  });

  useEffect(() => {
    if (value !== prev_value) {
      setPrevValue(value);
      setValueChanged(true);
    }
  }, [value, prev_value]);

  useEffect(() => {
    if (value_changed) {
      setValueChanged(false);
      setValue(value ? value : "");
      setValues(values);
    }
  }, [value, values, value_changed]);

  useEffect(() => {
    if (!common_util.listsMatch(values, prev_values)) {
      setPrevValues(values);
      setValueChanged(true);
    }
  }, [values, prev_values]);

  const load = () => {
    setFetched(true);
    const string_suggestions = api.string_suggestions.find(o => o.field === field);
    // if (field === "age_category") {
    //   debugger;
    // }
    if (string_suggestions) {
      setSuggestions([...string_suggestions.suggestions]);
      setLoading(false);
    } else if (SUGGESTION_FIELD_DATA_TYPE_MAP[field]) {
      setLoading(true);
      api.getObjectFieldValuesForDataTypes(SUGGESTION_FIELD_DATA_TYPE_MAP[field], field).then(res => {
        const suggs = (res as string[]).filter(o => o !== "");
        if (value !== null && value !== "") {
          if (!suggs.includes(value)) {
            suggs.push(value);
          }
        } else if (values.length > 0) {
          for (const v of values) {
            if (!suggs.includes(v)) {
              suggs.push(v);
            }
          }
        }
        api.string_suggestions.push({ field, suggestions: suggs });
        setSuggestions([...suggs]);
        setLoading(false);
      });
    }
  }

  const addNewSuggestion = (newSuggestionStr: string) => {
    const string_suggestions = api.string_suggestions.filter(o => o.field === field)[0];
    if (string_suggestions) {
      string_suggestions.suggestions.push(newSuggestionStr);
    } else {
      // Should never come here
      api.string_suggestions.push({ field, suggestions: [newSuggestionStr] });
    }
    setSuggestions([...suggestions, newSuggestionStr]);
  }

  const renderControl = () => {
    if (multiple) {
      return (
        <Stack spacing={2}>
          <Autocomplete
            freeSolo
            disableClearable
            options={suggestions}
            multiple
            value={myValues}
            disabled={disabled}
            renderInput={(params) => (
              <TextField
                {...params}
                label={ name }
                InputProps={{
                  ...params.InputProps,
                  type: 'search',
                }}
              />
            )}
            onChange={(event: any, new_values: string[]) => {
              // debugger;
              const new_value = new_values.find(o => !myValues.includes(o));
              onChange(new_values);
              setValues(new_values);
              if (new_value && !suggestions.includes(new_value)) {
                addNewSuggestion(new_value);
              }
            }}
          />
        </Stack>
      );
    } else {
      const use_suggestions = suggestions.includes("None") ? suggestions : ["None",...suggestions];
      return (
        <Stack spacing={2}>
          <Autocomplete
            freeSolo
            disableClearable
            options={use_suggestions}
            value={ myValue }
            disabled={disabled}
            renderInput={(params) => (
              <TextField
                {...params}
                label={ name }
                InputProps={{
                  ...params.InputProps,
                  // type: 'search',
                }}
              />
            )}
            onChange={(event: any, new_value: string) => {
              // debugger;
              if (new_value === "None") {
                onChange("");
                setValue("");
              } else {
                onChange(new_value);
                setValue(new_value);
                if (!suggestions.includes(new_value)) {
                  addNewSuggestion(new_value);
                }
              }
            }}
          />
        </Stack>
      );
    }
  }

  if (field === "") {
    return <span></span>;
  } else if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    if (color !== "") {
      return (
        <div style={{
          border: "1px solid #1C9AEF"
        }}>
          { renderControl() }
        </div>
      );
    } else {
      return renderControl();
    }
  }
}
